export const GRAPH_ROUTES = {
  REDIRECT: '/graph/openid/return',
  REDIRECT_ADMIN: '/graph/openid/admin/return',
  CHECK: '/graph/check',
  REGISTRATION: '/graph/registration'
};

export const ADMIN_ID = 0;
